module.exports = __webpack_public_path__ + "static/media/train2.f71493ab.jpg";